export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14948.d7fd8a8b.jpg";